export default "__VITE_ASSET__Re$fjczd__"